import {
  AssetImportance,
  AssetType,
  DeviceCategory,
  OSFamily,
  ResolutionType,
  Severity,
  Source,
  State,
  Status,
} from '@rtkwlf/mr-infra-risk';
import type { ArrayParam, NumberParam, StringParam } from 'use-query-params';
import { createEnumArrayParam } from 'use-query-params';

import type { GridSelectOperator } from '@packages/fenrir/components';

import type { UnixDateParam } from '../../query-params/unix-date-param';

export const StateParam = createEnumArrayParam(Object.values(State));
export const StatusParam = createEnumArrayParam(Object.values(Status));
export const SourceParam = createEnumArrayParam(Object.values(Source));
export const SeverityParam = createEnumArrayParam(Object.values(Severity));
export const ResolutionTypeParam = createEnumArrayParam(
  Object.values(ResolutionType),
);
export const CriticalityParam = createEnumArrayParam(
  Object.values(AssetImportance),
);
export const DeviceCategoryParam = createEnumArrayParam(
  Object.values(DeviceCategory),
);
export const DeviceOSParam = createEnumArrayParam(Object.values(OSFamily));

export const AssetTypeParam = createEnumArrayParam(Object.values(AssetType));

export type acceptedParamTypes =
  | typeof NumberParam
  | typeof ArrayParam
  | typeof StatusParam
  | typeof SourceParam
  | typeof StateParam
  | typeof SeverityParam
  | typeof ResolutionTypeParam
  | typeof UnixDateParam
  | typeof StringParam
  | typeof CriticalityParam
  | typeof DeviceCategoryParam
  | typeof DeviceOSParam
  | typeof AssetTypeParam;

export type defaultFilter = {
  id: number;
  field: string;
  operator: GridSelectOperator;
  value: string;
}[];
